import styled from "styled-components";

export const FaqWrapper = styled.div`
  padding: 16px;

  p {
    font-weight: 600;
    font-weight: 16px;
  }
`

export const FrequentAskQuestion = styled.div`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
  position: relative;
  border-radius: 1.2rem;
  padding: 16px;
  margin-right: 2rem;
  width: 100%;
  margin-bottom: 2rem;
`

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 10px;
`

export const FrequentAskQuestionImg = styled.div`
  width: 45px;
  margin-right: 10px;
`

export const FrequentAskQuestionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
`

export const FrequentAskQuestionSubtitle = styled.div`
  font-size: 14px;
  color: #777;
`

export const QuestionAnswerContainer = styled.div`
  border-bottom-style: solid;
  border-bottom-width: 0.1px;
  border-bottom-color: #777;
`

export const QuestionContainer = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 4px;
  padding-left: 6px;
`

export const AnswerContainer = styled.div`
  font-size: 14px;
  color: #777;
  padding-bottom: 10px;
  padding-left: 6px;
`

export const FrequentAskQuestionViewAll = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2276e3;
  cursor: pointer;
  padding-top: 16px;
  padding-left: 6px;
`